import CheapestTimeTo from './CheapestTimeTo';

export default CheapestTimeTo;
